import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Esto es una religión?',
    a: 'No, es tecnología de la conciencia.'
  }, {
    q: '¿Tengo libre albedrío?',
    a: 'Tienes el poder total de elegir el estado de conciencia con el que atraviesas tus hitos pactados.'
  }, {
    q: '¿Cómo me ayuda con mis problemas de dinero o pareja?',
    a: 'Cuando cambias la frecuencia del Observador, el colapso de la materia cambia. El afuera sigue al adentro.'
  }, {
    q: '¿Qué pasa si tengo miedo?',
    a: 'El miedo es solo información del personaje. Este manual te enseña a mirarlo como el Operador.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 bg-navy-950 border-t border-white/5" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10 text-white" data-id="element-16">
            Preguntas <span className="text-gold-400" data-id="element-17">Frecuentes</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-19">
              <div className="border border-white/10 rounded-lg overflow-hidden bg-navy-900/30" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-21">
                  <span className="text-lg font-medium text-white pr-4" data-id="element-22">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
                </button>
                <AnimatePresence data-id="element-24">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-25">
                      <div className="px-6 pb-5 text-gray-400 text-lg" data-id="element-26">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}